import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { Effects } from '@/view/pages/Decoupages/Effects';

export const Route = createFileRoute('/_protected/$programId/decupagens/efeitos')({
  component: Effects,
  validateSearch: z.object({
    numeroCena: z.string().optional().catch(''),
    numeroCapitulo: z.number().optional().catch(0),
  }),
  context: (context): { title: string } => ({
    ...context,
    title: 'Decupagem de Efeitos Especiais',
  }),
});
